module.exports = __webpack_public_path__ + "static/media/step1.6f06efaf.png";